import React, {FC} from "react";
import {ArrowRightIcon} from "@heroicons/react/solid";
import ButtonSecondary from "../../components/Button/ButtonSecondary";
import ButtonPrimary from "../../components/Button/ButtonPrimary";

export interface SectionCoin2Props {
  className?: string;
  rightImg?: string;
  coinName: string
}

const SectionCoin2:FC<SectionCoin2Props> = ({coinName}) => {

  return (
    <div
      className={`text-center justify-center SectionCoin2 relative flex flex-col lg:flex-row items-center `}
      data-id="SectionCoin2"
    >
      <div className="text-center justify-center flex-shrink-0 mb-14 lg:mb-0 lg:mr-10 lg:w-2/5">
        <h2 className="font-semibold text-3xl sm:text-4xl mt-3">
          {coinName} data from real-world markets.
        </h2>
        <span className="justify-center block mt-8 text-neutral-500 dark:text-neutral-400">
          We deliver verified data from high-quality sources on demand to help you make informed decisions.
        </span>
        <div className="flex space-x-4 mt-1 justify-center py-10">
          <div className="flex space-x-4 mt-11">
            <ButtonPrimary href={"/Markets"}>Back To Markets <ArrowRightIcon className="w-5 h-5 ml-2"/>
            </ButtonPrimary>
            <ButtonSecondary href={"/Learn"}>
              Learn The Data
              <ArrowRightIcon className="w-5 h-5 ml-2"/>
            </ButtonSecondary>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SectionCoin2;
